module.exports = __webpack_public_path__ + "static/media/ball_goal.d80e4b50.jpg";